/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.10.1
 * @since 1.0.0
 */

import { ChangeEvent, FormEvent, Fragment } from 'react';

import { people } from '../../../../assets/icons';
import { BlockWithIcon, Button, Input, LinkBlock } from '../../../../components/common';
import { FlexStyled } from '../../../../components/common/Block/Flexbox';
import {
    FormContainerStyled,
    FormGroupStyled,
    FormSubtitleStyled,
    FormTitleStyled,
    FormWrapperStyled,
} from '../../styled/PageAuthStyled';
import { Column, Question } from './styled/RecoveryFormStyled';

export interface IRecoveryFormProps {
    answer: string;
    backToAuth: string;
    buttonBack: string;
    buttonSubmit: string;
    inputHandler: (event: ChangeEvent<HTMLInputElement>, field: string) => void;
    labelLogin: string;
    login: string;
    question: string | null;
    submitHandler: (event: FormEvent, type: string) => void;
    subTitle: string;
    title: string;
    type: string;
    userAnswer: string;
    ussd: string;
}

const RecoveryForm = (props: IRecoveryFormProps) => {

    const getForm = (): JSX.Element => {
        const {
            answer,
            backToAuth,
            buttonBack,
            buttonSubmit,
            labelLogin,
            login,
            question,
            submitHandler,
            subTitle,
            title,
            type,
            userAnswer,
            ussd,
        } = props;
        switch (type) {
            case 'ussd':
                return (
                    <Column
                        className="recovery-form__ussd-message"
                    >
                        <FormTitleStyled>{title}</FormTitleStyled>
                        <p className="recovery-form__ussd-message">{ussd}</p>
                        <LinkBlock url="/login">
                            {backToAuth}
                        </LinkBlock>
                    </Column>
                );
            case 'question':
                return (
                    <Fragment>
                        <FormWrapperStyled
                            className="recovery-form__question"
                            onSubmit={(event: FormEvent) => submitHandler(event, 'answer')}
                        >
                            <FormTitleStyled>{title}</FormTitleStyled>
                            <FormSubtitleStyled>{subTitle}</FormSubtitleStyled>
                            <Question>{question}</Question>
                            <FormGroupStyled className="recovery-form__input-login-container">
                                <Input
                                    className="recovery-form__input-answer"
                                    data-input-login="loginRecoveryAnswer"
                                    label={answer}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => props.inputHandler(e, 'answer')}
                                />
                            </FormGroupStyled>
                            <FlexStyled alignItems="center" justifyContent="space-between">
                                <Button
                                    className="recovery-form__submit-button"
                                    dataName="buttonSubmitRecoveryAnswer"
                                    disabled={(userAnswer === '')}
                                    kind="medium"
                                >
                                    {buttonSubmit}
                                </Button>
                                <LinkBlock className="recovery-form__button-back"
                                           data-link-recovery="toBack"
                                           url="/login">
                                    {buttonBack}
                                </LinkBlock>
                            </FlexStyled>
                        </FormWrapperStyled>
                        <BlockWithIcon
                            iconRight={people}
                            iconRightSize={64}
                            justifyContent="flex-end"
                        />
                    </Fragment>
                );
            default:
                return (
                    <Fragment>
                        <FormWrapperStyled
                            className="recovery-form recovery-form__login"
                            onSubmit={(event: FormEvent) => submitHandler(event, 'login')}
                        >
                            <FormTitleStyled>{title}</FormTitleStyled>
                            <FormSubtitleStyled>{subTitle}</FormSubtitleStyled>
                            <FormGroupStyled className="recovery-form__input-login-container">
                                <Input
                                    className="recovery-form__input-login"
                                    data-input-login="loginRecovery"
                                    label={labelLogin}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => props.inputHandler(e, 'login')}
                                />
                            </FormGroupStyled>
                            <FlexStyled alignItems="center" justifyContent="space-between">
                                <Button
                                    className="recovery-form__submit-button"
                                    dataName="buttonSubmitRecovery"
                                    disabled={(login === '')}
                                    kind="medium"
                                >
                                    {buttonSubmit}
                                </Button>
                                <LinkBlock className="recovery-form__button-back"
                                           data-link-recovery="toBack"
                                           url="/login">
                                    {buttonBack}
                                </LinkBlock>
                            </FlexStyled>
                        </FormWrapperStyled>
                        <BlockWithIcon
                            iconRight={people}
                            iconRightSize={64}
                            justifyContent="flex-end"
                        />
                    </Fragment>
                );
        }
    };

    return (
        <FormContainerStyled>
            {getForm()}
        </FormContainerStyled>
    );
};

export default RecoveryForm;
